module.exports = __webpack_public_path__ + "ff7da966c6e49937aed6e3603ce5efd5.png";